import { render, staticRenderFns } from "./tm-get-app-page.vue?vue&type=template&id=c4fe0198&scoped=true&"
import script from "./tm-get-app-page.vue?vue&type=script&lang=ts&"
export * from "./tm-get-app-page.vue?vue&type=script&lang=ts&"
import style0 from "./tm-get-app-page.vue?vue&type=style&index=0&id=c4fe0198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fe0198",
  null
  
)

export default component.exports